export enum EnumFileType {
  Template = 1,
  Document = 2,
  DispatchDocument = 3,
  ProcedureDocument = 4,
  RegulatoryDocument = 5,
  InvoiceDocument = 6
}
